<div class="login-container">
  <div class="login-form">
    <div class="login-form-title">LOGIN</div>
    @if(isConfirmed) {
      <div class="login-form-container-confirmed">
        <div class="login-form-container-confirmation-code-label">{{'Your account has been activated. '}}
          <div class="login-form-container-confirmation-code-label bold">{{' Try to Login'}}</div>
        </div>
      </div>
    }
    <form [formGroup]="form" class="login-form-container">
      <label for="email-input" class="login-form-container-label">Email</label>
      <input 
      id="email-input"
      [ngClass]="{'login-form-container-input__error': form.get('email')?.invalid && form.get('email')?.touched}"
      class="login-form-container-input" 
      type="text" 
      formControlName="email">

      @if(form.get('email')?.invalid && form.get('email')?.touched) {
        <span class="login-form-container-error">Email is required</span>
      }

      <div class="login-form-container-password-container">
        <label for="password-input" class="login-form-container-label">Password</label>
        <div class="login-form-container-label forgot-password-label" [routerLink]="['/reset']" tabindex="-1">Forgot Password?</div>
      </div>
      
      <div class="password-input-wrapper">
        <input 
          id="password-input"
          [ngClass]="{'login-form-container-input__error': form.get('password')?.invalid && form.get('password')?.touched}"
          class="login-form-container-input" 
          [type]="showPassword ? 'text' : 'password'" 
          formControlName="password">
        <img 
          [src]=" showPassword ? 'assets/imgs/password-eye.svg' : 'assets/imgs/show-password.svg'" 
          class="password-toggle" 
          [class.visible]="showPassword"
          (click)="togglePasswordVisibility()" 
          alt="toggle password visibility">
      </div>

      @if(form.get('password')?.hasError('minlength') && form.get('password')?.touched) {
        <span class="login-form-container-error">Minimum 6 characters</span>
      }
     
    
      <div class="login-form-container-button-container">
        <button
        class="login-form-container-button red-button"
        [ngClass]="{'disabled': form.invalid || loading}"
        [disabled]="form.invalid || loading"
        (click)="login()"
        >
        @if(loading) {
         Loading...
        }@else {
          LOGIN
        }
      </button>

        <div class="login-form-container-button-row">
          <button
          class="login-form-container-button dark-button"
          [routerLink]="['/magic-link']"
          ><span class="button-subtitle">login with</span>MAGIC LINK</button>

          <!-- <button
          class="login-form-container-button dark-button"
          [routerLink]="['/phone-login']"
          ><span class="button-subtitle">login with</span>PHONE</button> -->
        </div>

        <button
        class="login-form-container-button dark-button"
        [routerLink]="['/register']"
        >REGISTER HERE</button>

      </div>
    </form>
  </div>
</div>